import store from '../../store'
import createAxios from './api'

const PATH_RSSP = '/rssp/v1/'

// public enum CredentialStatus {
//   CREATED,
//   ACTIVATED
// }
// no 'status' query, no filter
// 'status' should be 'CREATED' or 'ACTIVATED'
export default {
  async createCredential(req) {
    const axios = await createAxios(true)
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials/'
    await axios.post(fullurl, req)
  },

  async getCredential(id) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials/'
    const resp = await axios.get(`${fullurl}${id}`)

    return resp.data
  },

  async getCertificateInfo(pem) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials/'
    const resp = await axios.post(`${fullurl}certificateInfo`, { pem })

    return resp.data
  },

  async listMyCredentials(status, q, pageRequest, idToken = null) {
    // const axios = await createAxios(true, null, idToken)
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials/self'

    const resp = await axios.get(fullurl, {
      params: {
        status,
        q: q?.toString() || '',
        ...pageRequest
      }
    })

    return resp.data
  },
  async listMyActivatedCredentials() {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials/self?status=ACTIVATED'
    const resp = await axios.get(fullurl)
    return resp.data
  },
  async listCredentials(userId, q, pageRequest) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    const resp = await axios.get(fullurl, {
      params: {
        userId,
        q: q?.toString() || '',
        ...pageRequest
      }
    })

    return resp.data
  },

  async updateCredential(id, req) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    await axios.put(`${fullurl}/${id}`, req)
  },

  async deleteCredential(id) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    await axios.delete(`${fullurl}/${id}`)
  },

  async activateCredential(id, req, timeOut) {
    const axios = await createAxios(true, timeOut)
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    await axios.post(`${fullurl}/${id}/activate`, req)
  },

  async changePassword(id, req, timeOut) {
    const axios = await createAxios(true, timeOut)
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    await axios.post(`${fullurl}/${id}/changePassword`, req)
  },

  async unlock(id, req, timeOut) {
    const axios = await createAxios(true, timeOut)
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    await axios.post(`${fullurl}/${id}/unlock`, req)
  },

  async changePuk(id, req, timeOut) {
    const axios = await createAxios(true, timeOut)
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    await axios.post(`${fullurl}/${id}/changePuk`, req)
  },

  async replaceCertificateChain(id, certChain) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    await axios.put(`${fullurl}/${id}/certificateChain`, certChain)
  },

  async clearCredentialPreauthorization(id) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'credentials'
    await axios.post(`${fullurl}/${id}/clearPreauthorization`)
  },

  async listMyDevices() {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'devices/self'
    const resp = await axios.get(fullurl)
    return resp.data
  },

  async updateMyUser(user) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'users/self'
    const resp = await axios.put(fullurl, user)
  },

  async updateMyLocale(locale) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'users/self/locale'
    const resp = await axios.put(fullurl, locale)
  },

  async joinUserOnRssp() {
    const axios = await createAxios()
    const resp = await axios.put(store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'users', store.state.currentUser)

    return resp.data
  },
  async listUsers(q, pageRequest) {
    const axios = await createAxios()
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'users'
    const resp = await axios.get(fullurl, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async getCountryList(langCode) {
    const axios = await createAxios(false)
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'server'
    const resp = await axios.get(`${fullurl}/countries/${langCode}`)

    return resp.data
  },
  async getRemoteConfig() {
    const axios = await createAxios(false)
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + 'server'
    const resp = await axios.get(`${fullurl}/config/`)

    return resp.data
  }
}
